import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { getRoleEnterSceneData } from '@/api/data';
import serverList from "../../../components/serverList/serverOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import { getSceneMap } from '../../../utils/dictionary';
export default {
  components: {
    serverList: serverList,
    DataOptions: DataOptions
  },
  data: function data() {
    return {
      tableData: [],
      serverInfo: [],
      sceneNameDict: {},
      dateInfo: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")]
    };
  },
  methods: {
    onSearchBtn: function onSearchBtn() {
      var _this = this;
      var searchInfo = {
        sdate: this.dateInfo[0],
        edate: this.dateInfo[1],
        server_id: this.serverInfo
      };
      searchInfo.server_id = this.serverInfo;
      var _iterator = _createForOfIteratorHelper(searchInfo.server_id),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var serverId = _step.value;
          if (serverId == '0') {
            searchInfo.server_id = [];
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      getRoleEnterSceneData(searchInfo).then(function (res) {
        _this.tableData = res.data;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getSceneMap().then(function (result) {
              _this2.sceneNameDict = result;
            });
            _this2.onSearchBtn();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};